import { MRT_ColumnDef } from 'mantine-react-table';
import { TrackLabel } from '@bariendo/lib/constants';
import { PatientExportRow, UNKNOWN_TRACK_LABEL } from './rows';

/**
 * Column defs for the export table. Every column is filterable — `filterVariant` picks the control,
 * and the table's `enableColumnFilterModes` adds per-column operators, which together give the
 * stackable filtering the Retool tool's "Filter" button provided.
 */
export function getPatientExportColumns(): MRT_ColumnDef<PatientExportRow>[] {
  return [
    { accessorKey: 'firstName', header: 'First name' },
    { accessorKey: 'lastName', header: 'Last name' },
    { accessorKey: 'email', header: 'Email' },
    { accessorKey: 'mobile', header: 'Mobile' },
    { accessorKey: 'birthDate', header: 'Date of birth' },
    { accessorKey: 'procedureDate', header: 'Procedure' },
    { accessorKey: 'procedureType', header: 'Procedure type', filterVariant: 'multi-select' },
    { accessorKey: 'site', header: 'Site', filterVariant: 'multi-select' },
    {
      accessorKey: 'track',
      header: 'Track',
      filterVariant: 'multi-select',
      // "Unknown" is offered explicitly: most patients have no track episode yet, so without it the
      // filter can't select the majority of rows.
      mantineFilterMultiSelectProps: { data: [...Object.values(TrackLabel), UNKNOWN_TRACK_LABEL] },
    },
    { accessorKey: 'employer', header: 'Employer', filterVariant: 'multi-select' },
    { accessorKey: 'currentState', header: 'Current state', filterVariant: 'multi-select' },
  ];
}
